import { InputField } from '../../../Input'
import { Control } from '../Control'

function ControlNumber({ max, min, value, onChange, ...controlProps }) {
  function handleChange(event) {
    onChange(value, { value: Number(event.target.value) })
  }

  return (
    <Control {...controlProps} value={value} onChange={onChange}>
      <InputField
        borderless
        disabled={value.omitted}
        max={max}
        min={min}
        type='number'
        value={(value.value ?? 0).toFixed()}
        onChange={handleChange}
      />
    </Control>
  )
}

export default ControlNumber
